export default __webpack_public_path__ + "static/media/regulatory--bicycles-only--g2.1e88f01e.png";